import React from 'react';
import {
  Dialog,
  Box,
} from '@material-ui/core';
import { useStoreState } from 'easy-peasy';
import UserFormFields from './userFormFields/userFormFields';
import styles from './usermodal.module.scss';
import {
  globalPageTypeEntity,
} from '../../../constants/applicationConstants';

const UserModal = (props) => {

  const {onCancel, open, opts, onSave} = props;

  const [userInfo, setUserInfo] = React.useState({});

  React.useEffect(() => {
    let userInfoObj = {...opts.userInfo}
    if (userInfoObj.user_policies && typeof userInfoObj.user_policies === 'string') {
      userInfoObj.user_policies = userInfoObj.user_policies.split(',');
    }
    setUserInfo(userInfoObj)
  }, [opts.userInfo]);

  const moduleAccessPermissions = useStoreState(
    (state) => state.login.moduleAccessPermissions,
  );

  const editAccess = moduleAccessPermissions.users.access_level
    ? moduleAccessPermissions.users.access_level.some((item) => {
      return item === globalPageTypeEntity.edit;
    })
    : false;
  
  return (
    <Dialog
      disableBackdropClick
      disableEscapeKeyDown
      fullWidth
      maxWidth={'lg'}
      aria-labelledby="confirmation-dialog-title"
      PaperProps={{
        style: { borderRadius: 20 }
      }}
      open={open}
    >
      <Box className={styles.dialogmainwrapper}>
        <UserFormFields
          history={props.history}
          editAccess={editAccess}
          formValues={userInfo}
          pageType={ opts.pageType }
          onDone={onSave}
          cancelClick={onCancel}
        />
      </Box>
    </Dialog>
  );
};

export default UserModal;